import { UseQueryOptions } from '@tanstack/react-query';

import useQuery from 'hooks/useQuery';
import { CuredApiPaths } from 'models/enums';

import QueryKeys from './keys';

export type CampaignExitStatsResponse = {
    exitedCount: number;
};

/**
 * Returns the number of contacts that have exited a campaign via its exit criteria.
 * - GET /campaigns/:campaignId/exit-stats
 * @param campaignId the UUID of the campaign
 * @param reactQueryOptions options for the react-query hook
 * @returns a react-query object
 */
const useCampaignExitStats = (
    campaignId: string,
    reactQueryOptions?: UseQueryOptions<CampaignExitStatsResponse, Error>
) => {
    const path = `${CuredApiPaths.CAMPAIGNS}/${campaignId}/exit-stats`;

    return useQuery<CampaignExitStatsResponse>(QueryKeys.CAMPAIGN_EXIT_STATS(campaignId), path, reactQueryOptions);
};

export default useCampaignExitStats;
